import { Reducer } from 'redux';
import { BlackListState, BlackListTypes } from './types';

const INITIAL_STATE: BlackListState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,

  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<BlackListState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BlackListTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BlackListTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case BlackListTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case BlackListTypes.FILTER_BLACKLIST:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case BlackListTypes.CLEAN_BLACKLIST:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
